import React from "react";
import { formatCurrency } from "../../../helpers/estimateTotals";
import { formatTaxLineLabel } from "../../../helpers/estimateTax";
import { getEstimateTotalPresentation } from "../../../helpers/estimateReport";

/**
 * Estimate total block — controlled by Show Estimate Total report option.
 * Taxes are included here; no separate Show Taxes toggle.
 */
export function EstimateReportTotalSection({
  reportModel,
  variant = "preview",
}) {
  const presentation = getEstimateTotalPresentation(reportModel);
  if (!presentation) return null;

  const isPrint = variant === "print";
  const rowClass = isPrint ? "erp-totals-row" : "er-summary-row";
  const emphasisRowClass = isPrint
    ? "erp-totals-row erp-totals-row--grand"
    : "er-summary-row er-summary-row--emphasis";

  if (presentation.mode === "withTax") {
    const blockClass = isPrint ? "erp-totals-block" : "er-report-totals";

    return (
      <div className={blockClass}>
        <div className={rowClass}>
          <span>Subtotal</span>
          <span>{formatCurrency(presentation.subtotal)}</span>
        </div>
        {presentation.lines.map((line) => (
          <div key={`${line.type}-${line.label}`} className={rowClass}>
            <span>{formatTaxLineLabel(line)}</span>
            <span>{formatCurrency(line.amount)}</span>
          </div>
        ))}
        <div className={emphasisRowClass}>
          <span>{presentation.totalLabel}</span>
          <span>{formatCurrency(presentation.total)}</span>
        </div>
      </div>
    );
  }

  if (isPrint) {
    return (
      <div className="erp-totals-block">
        <div className={emphasisRowClass}>
          <span>{presentation.totalLabel}</span>
          <span>{formatCurrency(presentation.total)}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="er-grand-total">
      <div className="er-grand-total-label">{presentation.totalLabel}</div>
      <div className="er-grand-total-amount">
        {formatCurrency(presentation.total)}
      </div>
    </div>
  );
}
